import React, { Fragment, useState, useEffect } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Grid, IconButton, Chip } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { setCurrentPage } from "actions";

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MUIDataTable: {
        filterPaper: {
          width: "500px", // フィルターダイアログの幅を500pxに設定
        },
      },
    },
  });

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      position: "fixed",
      backgroundColor: "#fafafa",
      zIndex: 1000,
      width: "100%",
    },
    alignLeft: {
      lineHeight: "18px",
      textAlign: "left",
    },
    summaryCenter: {
      textAlign: "center",
    },
    cvrHead: {
      textAlign: "center",
      fontSize: 12,
      fontWeight: "normal",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    flexItemLeftBox: {
      marginTop: 28,
      alignSelf: "center",
      paddingLeft: 8,
      paddingRight: 8,
      borderRight: "1px solid #dcdcdc",
    },
  })
);

const GroupTable = ({
  setCurrentPage,
  tableRowSelected,
  groupSummaryData,
}) => {
  const classes = useStyles();

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  const getGroupSummaryData = (data) => {
    if (data.length > 0) {
      let allDataArray = [],
        eachDataArray = [];
      for (let i = 0; i < data.length; i++) {
        eachDataArray.push(data[i]["groupId"]);
        eachDataArray.push(data[i]["groupName"]);
        eachDataArray.push(data[i]["playerCount"]);
        allDataArray.push(eachDataArray);
        eachDataArray = [];
      }
      return allDataArray;
    }
  };

  const getColumns = () => {
    let returningColumn = columns;
    if (
      localStorage.getItem("access_key") !== process.env.REACT_APP_SUPERUSER
    ) {
      returningColumn.pop();
    }
    return returningColumn;
  };

  const options = {
    filterType: "dropdown",
    filter: true,
    pagination: true,
    search: true,
    print: false,
    download: true,
    downloadOptions: {
      filename: "登録グループ一括データ",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    selectableRows: "none",
    rowsPerPage: 100,
    rowsSelected: tableRowSelected,
    textLabels: {
      body: {
        noMatch: "データを取得中です。",
        toolTip: "",
      },
      toolbar: {
        search: "検索",
        viewColumns: "列の表示",
        downloadCsv: "CSVダウンロード",
        filterTable: "テーブルのフィルター",
      },
      viewColumns: {
        title: "表示する列",
        titleAria: "テーブルの列の表示/非表示",
      },
      pagination: {
        next: "次のページ",
        previous: "前のページ",
        rowsPerPage: "表示件数",
      },
      filter: {
        all: "全て",
        title: "フィルター",
        reset: "リセット",
      },
      selectedRows: {
        text: "レコードを選択",
        delete: "削除",
        deleteAria: "選択したレコードを削除する",
      },
    },
    rowsPerPageOptions: [10, 50, 100],
  };

  let columns = [
    {
      name: "グループID",
      options: {
        filter: true,
        customFilterListRender: (v) => `グループID: ${v}`,
        customHeadLabelRender: () => (
          <div style={{ textAlign: "left", width: "100%" }}>グループID</div>
        ),
        customBodyRender: (value) => {
          return <div className={classes.alignLeft}>{value}</div>;
        },
      },
    },
    {
      name: "グループ名",
      options: {
        filter: true,
        customFilterListRender: (v) => `グループ名: ${v}`,
        customHeadLabelRender: () => (
          <div style={{ textAlign: "left", width: "100%" }}>グループ名</div>
        ),
        customBodyRender: (value) => {
          return <div className={classes.alignLeft}>{value}</div>;
        },
      },
    },
    {
      name: "登録プレイヤー数",
      options: {
        filter: false,
        customFilterListRender: (v) => `登録プレイヤー数: ${v}`,
        customBodyRender: (value) => {
          return <div className={classes.summaryCenter}>{value}</div>;
        },
      },
    },
  ];

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MUIDataTable
            title={`登録グループ：${groupSummaryData?.groupCount || 0}件`}
            data={getGroupSummaryData(groupSummaryData?.groupData || [])}
            columns={getColumns()}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  );
};

GroupTable.propTypes = {
  classes: PropTypes.object,
  groupSummaryData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

const mapStateToProps = (state) => ({
  tableRowSelected: state.page.tableRowSelected,
  groupSummaryData: state.pictreeHokuden.groupSummaryData,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupTable);
